import styled from 'styled-components'

export const PageHeading = styled.h2`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.8px;
  vertical-align: middle;
  margin: 0;
`

export const Section = styled.div`
  & + & {
    margin-top: 3.125rem;
  }
`

export const SectionTitle = styled.h2`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: -0.8px;
  vertical-align: middle;
  margin: 0 0 20px;
`
